import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Alpha Consulting LLC | Product Engineering & Cloud Solutions',
  description = 'Leading SaaS product engineering and cloud solutions provider. We design, build, and scale web and mobile products. Expert team delivering custom software, automation, and enterprise solutions.',
  keywords = 'product engineering, cloud solutions, SaaS development, custom software, web development, mobile app development',
  url,
  image = 'https://thealphaconsult.com/3ff0f777-6fef-48b9-81ec-9c3949d95efa_3840.png',
  type = 'website',
  robots = 'index, follow',
  structuredData
}) => {
  // Derive current URL from runtime to keep domains consistent across environments
  const runtimeOrigin = (typeof window !== 'undefined' && window.location.origin)
    ? window.location.origin
    : (process.env.REACT_APP_SITE_URL || 'https://thealphaconsult.com');
  const runtimeHref = (typeof window !== 'undefined' && window.location.href)
    ? window.location.href
    : runtimeOrigin;
  const canonicalUrl = url || runtimeHref;
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={robots} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical */}
      <link rel="canonical" href={canonicalUrl} />

      {structuredData ? (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      ) : null}
    </Helmet>
  );
};

export default SEO;
